/** Indicates how important a given notification is. */
export enum NotificationLevel {
  Debug = 0,
  Info = 1,
  Warn = 2,
  Error = 3,
  Fatal = 4,
}
